export default "__VITE_ASSET__BmBPPcX$__"